<template>
  <KarteUserListItemInformationText
    v-if="currentVariant"
    :class="[$style.text, $style[currentVariant.classModifier]]"
  >
    {{ currentVariant.text }}
  </KarteUserListItemInformationText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import KarteUserListItemInformationText from './KarteUserInformationText.vue'

const props = defineProps<{
  sameBranchPlannerCommented: boolean
  plannerCommentCount: number
  userNumberOfMatch: number
}>()

type Variant = {
  text: string
  classModifier: string
}

const currentVariant = computed<Maybe<Variant>>(() => {
  if (props.sameBranchPlannerCommented) {
    return {
      text: '同一支社のプランナーからアプローチがあります',
      classModifier: 'text--hasCoWorkerComments',
    }
  }
  if (props.plannerCommentCount >= 10) {
    return {
      text: '10件以上のアプローチがあり、マッチングの可能性が低い',
      classModifier: 'text--over10Comments',
    }
  }

  if (props.plannerCommentCount === 0) {
    return {
      text: 'まだ他のプランナーからアプローチを受けていない',
      classModifier: 'text--noComments',
    }
  }

  if (props.plannerCommentCount === 1 && props.userNumberOfMatch === 0) {
    // props.plannerCommentCount === 0 のときも最初のマッチになる可能性があるが、
    // その場合は「まだ他のプランナーからアプローチを受けていない」という文言が表示されるので、
    // 挙動が分かりやすいように、ここでは props.plannerCommentCount === 1 のときのみ表示する
    return {
      text: '最初のマッチになる可能性がある',
      classModifier: 'text--couldBeTheFirstMatch',
    }
  }

  return undefined
})
</script>

<style lang="scss" module>
.text {
  &--over10Comments {
    color: $color-label-red;
  }

  &--hasCoWorkerComments {
    color: $color-label-blue;
  }

  &--noComments {
    color: $color-label-green;
  }

  &--couldBeTheFirstMatch {
    color: $color-label-green;
  }
}
</style>
